import { useEffect }					from 'react';
import { useNavigate, useSearchParams }	from "react-router-dom";
import { useTranslation }				from "react-i18next";
import { demoPages }					from '../../../menu';
import { removeItem }					from '../../../lib/localstorage';
import { useMst }						from "../../../models";
import { Configs }						from '../../../models/Configs';
import authService						from "../../../services/AuthService";
import showNotification					from "../../../components/extras/showNotification";


const SimpleSso = () => {
	
	const { user, company }	= useMst()
	const [ searchParams, ]	= useSearchParams()
	const { t }				= useTranslation();
	const navigate			= useNavigate()
	
	// 넘겨진 인증 정보
	const ssoData			= searchParams.get('data');
	const signature			= searchParams.get('signature');
	
	// console.log(">> simple sso param:", ssoData, signature);
	
	// 기존 로그인된 사용자 로그아웃
	const logoutProcess = async () => {
		
		try {
			
			await authService.logout();
			
			await Promise.all([
				
				removeItem('access-token'),
				removeItem('refresh-token'),
				removeItem('rootState'),
				removeItem('webToken'),
				removeItem('authUser'),
				
				user.logout(),
				company.logout(),
			]);
		}
		catch (e) {
			
			console.log(">> simple sso process - logout err.. ", e);
		}
	};
	
	let runCnt = 0;
	
	// Simple SSO 로그인
	const simpleSsoProcess = async () => {
		
		if (runCnt > 0) {
			// 한번 실행 했으면 짜증나게 또 실행하지 마라..
			
			return;
		}
		else {
			
			runCnt++;
		}
		
		console.log(">> simple sso process - param:", ssoData, signature);
		
		await logoutProcess();// 로그아웃
		
		const res = await authService.simpleSso(ssoData, signature);
		
		const resCode		= res?.code;
		const resResult		= res?.result;
		const resMessage	= res?.message;
		const resData		= res?.data;
		
		console.log(">> simple sso process - simpleSso:", resCode, resResult, resMessage, resData);
		
		if (resCode != 200 && resMessage != null) {
			// 실패 메시지 출력
			
			showNotification(t('로그인'), t(resMessage), 'danger');
		}
		
		if (resResult != true) {
			
			navigate('/' + demoPages.login.path);
			
			return;
		}
		
		// 로그인 성공
		
		try {
			
			const authMe = await user.authMe();
			
			console.log(">> simple sso process - authMe:", authMe);
			
			{
				const currentCompanyId	= user?.me?.currentCompanyId;
				
				await Promise.all([
					
					Configs.sendDevice(),
					
					currentCompanyId && company.selectCompany(currentCompanyId),
				]);
			}
			
			if (user.me.id) {
				
				const currentCompanyId	= user?.me?.currentCompanyId;
				
				if (currentCompanyId == null || currentCompanyId === 0) {
					
					window.location.replace('/change-company');
				}
				else {
					
					window.location.replace('/');
				}
			}
		}
		catch(e) {
			
			console.log(">> simple sso process - login err.. ", e);
			
			showNotification(t('로그인'), t('로그인에 실패하였습니다.') + t('다시 확인해주세요') + '.', 'danger');
			
			navigate('/' + demoPages.login.path)
		}
	}
	
	useEffect(() => {// 이 망할것이 <React.StrictMode> 때문에 2번 실행된다
		
		simpleSsoProcess();
		
	}, [searchParams]);
};

export default SimpleSso
